import { AxiosError } from 'axios';
import { getRequestUrl } from './getRequestUrl';

export class ApiNetworkError extends Error {
  readonly code?: string;
  readonly url?: string;

  constructor(error: AxiosError) {
    super(error.message);

    this.name = 'ApiNetworkError';
    this.code = error.code;
    this.url = getRequestUrl(error);
  }
}
